import * as React from 'react';
import { range, round, minBy } from 'lodash';

export const makeTicksAndLabels = (min: number, max: number, {
    nTicks,
    nLabels = 0,
    precision = 0
  }: { nLabels?: number, nTicks?: number, precision?: number } = {}): string[] => {
    const tickValues = [
      ...range(min, max, nTicks),
      max
    ];
    const ticksPerLabel = nTicks / nLabels;
    const labelPositions = [
      ...range(0, nTicks, ticksPerLabel),
      nTicks
    ].map((n) => round(n));
    return tickValues
      .map((tickValue, index) => {
        if (labelPositions.indexOf(index) < 0) return null;
        return round(tickValue, precision).toString();
      });
};

interface Props {
  min: number;
  max: number;
  step?: number;
  value: number;
  ticks: number;
  labels: string[];
  id?: string;
  className?: string;
  onChange: (x: number) => void;
}

const Slider = ({ id, labels, value, min, max, onChange, className = '', step = 1, ticks = 0 }: Props) => (
  <div className="slider__container">
    <div>
      <input
        id={id}
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        className={`slider ${className}`}
        onChange={(e) => onChange(parseFloat(e.target.value))}
      />
    </div>
    {ticks > 0 &&
      <div
        className="slider__labels"
      >
        {range(ticks).map((index) => (
          <div
            className="slider__tick__container"
            key={index}
            onClick={() => onChange(
              minBy(
                [...range(min, max, step), max],
                (n) => Math.abs(n - (min + index * (max - min) / (ticks - 1)))
            ))}
          >
            <div className="slider__tick__mark">|</div>
            {labels[index] &&
              <div className="slider__tick__label">{labels[index]}</div>
            }
          </div>
        ))}
      </div>
    }
  </div>
);

export default Slider;
